const isScrollingDown = ref(false);
const oldScroll = ref();

export default () => {
	const scrollDelayBoundary = 100;

	function setScrollDirection() {
		isScrollingDown.value
			= window.scrollY > scrollDelayBoundary
				? oldScroll.value < window.scrollY
				: false;

		oldScroll.value = window.scrollY;
	}

	onMounted(() => {
		window.addEventListener('scroll', setScrollDirection);
	});

	onUnmounted(() => {
		window.removeEventListener('scroll', setScrollDirection);
	});

	return {
		isScrollingDown,
	};
};
